import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { NotFoundView } from 'app/views/layout/views/notFound';
import { LoadingScreen, MessengerSettingsPage } from './components';
import { useMessengerSettings } from './hooks';
import { extractInitialValuesFromMessenger } from './hooks/utils';
import { presetBackgrounds } from './presetBackgrounds';
export const MessengerSettingsView = () => {
    var _a, _b, _c;
    const { messengerId } = useParams();
    const { isLoading, setSettings, messenger, bulletinBoardId, fallbackSettings, } = useMessengerSettings(messengerId);
    const initialValues = extractInitialValuesFromMessenger(messenger, fallbackSettings);
    const avatars = (_c = (_b = (_a = messenger === null || messenger === void 0 ? void 0 : messenger.settings) === null || _a === void 0 ? void 0 : _a.avatars) === null || _b === void 0 ? void 0 : _b.map((avatar) => avatar.type === 'fixed' ? avatar.fixed.url : avatar.random.url)) !== null && _c !== void 0 ? _c : [];
    if (!messenger) {
        if (!isLoading) {
            return (_jsx(NotFoundView, { navigatePath: "/settings/dixa-messenger", name: "Messenger" }));
        }
        return _jsx(LoadingScreen, {});
    }
    if (!bulletinBoardId) {
        // bulletinBoardId is automatically created if it's missing.
        return _jsx(LoadingScreen, {});
    }
    return (_jsx(MessengerSettingsPage, { messengerId: messenger.id, messengerToken: messenger.token, onSubmit: setSettings, initialValues: initialValues, messengerName: messenger.name, presetBackgrounds: presetBackgrounds, isLoading: isLoading, bulletinBoardId: bulletinBoardId, avatars: avatars }));
};
